export default "__VITE_ASSET__2199ff6f__"